import { Vue, Prop, Component } from "vue-property-decorator";
import Event from "./event.model";

@Component
export default class ORSchedule extends Vue {
    @Prop() id!: string;
    @Prop() username!: string;
    @Prop() staffId!: string;
    @Prop() tenantId!: string;
    @Prop() startDate!: Date;
    @Prop() endDate!: Date;
    @Prop() status!: string;
    @Prop() current!: true;
    @Prop() facilityId!: string;
    @Prop() coid!: string;
    @Prop() facilityName!: string;
    @Prop() deptId!: string;
    @Prop() deptCode!: string;
    @Prop() deptName!: string;
    @Prop() events!: Event[];
}